import React from 'react';
import { FaTrophy, FaArrowRight } from 'react-icons/fa';
import { MatchResultForm } from '../components';

const Knockout = ({ knockoutMatches, addKnockoutResult }) => (
  <MatchResultForm
    matches={knockoutMatches}
    onAddResult={addKnockoutResult}
    title="Eliminatorias"
    icon={<FaTrophy />}
    description="Registra el marcador para definir finalistas."
    emptyIcon={<FaArrowRight />}
    emptyTitle="Esperando cruces"
    emptyDescription="Cuando tengas clasificados, genera eliminatorias desde la sección principal."
    submitLabel="Guardar resultado"
    submitButtonClassName="btn btn--accent"
  />
);

export default Knockout;
